import React from 'react'

type DynamicValues = {
  netInvestments: string
  projectedValue: string
  returnValue: string
  selectedAge: number
}

type PotentialContextTypes = {
  onChange: React.Dispatch<React.SetStateAction<DynamicValues>>
} & DynamicValues

const PotentialContext = React.createContext<PotentialContextTypes>({
  netInvestments: '$0',
  onChange: () => undefined,
  projectedValue: '$0',
  returnValue: '$0',
  selectedAge: 0,
})

const usePotential = (): PotentialContextTypes => {
  const { projectedValue, selectedAge, netInvestments, returnValue, onChange } =
    React.useContext(PotentialContext)

  return {
    netInvestments,
    onChange: onChange,
    projectedValue,
    returnValue,
    selectedAge,
  }
}

export { PotentialContext, usePotential }
